<template>
  <div class="col">
    <div id="main" class="col-main">
      <div class="row no-gutters row-main justify-content-center">
        <div class="col-12 col-lg-10 bg-white">
          <div class="row no-gutters justify-content-center">
            <div class="col-12 col-lg-9">
              <h2 class="section-title">Adult Cricket for All Abilities</h2>
            </div>

            <div class="col-12 col-lg-9">
              <!-- Text -->
              <p class="h5">
                The club has a successful adult section with all sides competing in the 
                <a href="https://www.middlesexccl.com/" target="_blank" rel="noreferer">Middlesex County Cricket League</a>.
              </p>
              <p class="h5">
                See our fixtures and results <a href="https://www.play-cricket.com/" target="_blank" rel="noreferer">here</a>.

              </p>
              <p class="text-strong h5">Training</p>
              <p class="h5">The club runs structured winter and summer training with ECB qualified coaches which take advantage of the top class Trailfinders facilities.
                <br/>
                <br/>
                There is further a 1st team performance academy developing our elite players.
                <br/>
                <br/>
                Join our community <a href="#/register?form=adult">here</a>.
              </p>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import EventBus from '../../eventBus'
export default {
  data() {
      return {
          year: ""
      }
  },
  mounted() {
    EventBus.$on("get-year", (year) => {
      this.year = year
    })
  }
};
</script>
<style>
</style>
